import { storableError } from '../../util/errors';
import { get } from '../../util/api';

// ================ Action types ================ //

const FETCH_WELFARE_STATS_REQUEST = 'app/WelfareIndexPage/FETCH_WELFARE_STATS_REQUEST';
const FETCH_WELFARE_STATS_SUCCESS = 'app/WelfareIndexPage/FETCH_WELFARE_STATS_SUCCESS';
const FETCH_WELFARE_STATS_ERROR = 'app/WelfareIndexPage/FETCH_WELFARE_STATS_ERROR';

// ================ Reducer ================ //

const initialState = {
  welfareStats: null,
  fetchInProgress: false,
  fetchError: null,
};

export default function welfareIndexPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_WELFARE_STATS_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_WELFARE_STATS_SUCCESS:
      return { ...state, fetchInProgress: false, welfareStats: payload };
    case FETCH_WELFARE_STATS_ERROR:
      return { ...state, fetchInProgress: false, fetchError: payload };
    default:
      return state;
  }
}

// ================ Thunks ================ //

export const fetchWelfareStats = () => dispatch => {
  dispatch({ type: FETCH_WELFARE_STATS_REQUEST });
  return get('/api/companies/welfare-stats')
    .then(response => {
      dispatch({ type: FETCH_WELFARE_STATS_SUCCESS, payload: response.data });
      return response;
    })
    .catch(e => {
      // Non-critical – page works without stats
      dispatch({ type: FETCH_WELFARE_STATS_ERROR, payload: storableError(e) });
    });
};

export const loadData = () => dispatch => {
  return dispatch(fetchWelfareStats());
};
